import { CommonProps } from "./types";

import { ActionsContainer } from "./Modal.styles";

function ActionButtons({ children, className }: CommonProps) {
  return <ActionsContainer className={className}>{children}</ActionsContainer>;
}

export { ActionButtons };
